import gql from 'graphql-tag';
import paymentFragment from './getOrderPaymentsQuery/payment.fragment.graphql';
import promoFragment from './getOrderPaymentsQuery/promo.fragment.graphql';
import voucherFragment from './getOrderPaymentsQuery/voucher.fragment.graphql';
import loyaltyPaymentFragment from './getOrderPaymentsQuery/loyaltyPayment.fragment.graphql';

export {
  paymentFragment,
  promoFragment,
  voucherFragment,
  loyaltyPaymentFragment,
};

export default gql`
  ${paymentFragment}
  ${promoFragment}
  ${voucherFragment}
  ${loyaltyPaymentFragment}

  query payment {
    order {
      price {
        balanceDue
      }
      loyalty {
        totalPoints
        totalAmount {
          amount
          currency
        }
        applicableAmount {
          amount
          currency
        }
        applicablePoints
        rewardPoints
        bonusPoints
        enrolled
        eligible
        bonusAndRewardPoints
      }
      payments {
        ...OrderPaymentFragment
        ...PromoPaymentFragment
        ...VoucherPaymentFragment
        ...LoyaltyPaymentFragment
      }
      promoError {
        name
        errors
      }
    }
  }
`;
